import { render } from "./PFaceUseEndPeriod.vue?vue&type=template&id=58d5d794&scoped=true"
import script from "./PFaceUseEndPeriod.vue?vue&type=script&lang=js"
export * from "./PFaceUseEndPeriod.vue?vue&type=script&lang=js"

import "./PFaceUseEndPeriod.vue?vue&type=style&index=0&id=58d5d794&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58d5d794"

export default script